import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from "./api";

export function getProducts(params = {}) {
  return apiGet("/catalog/products/", params);
}

export function getFeaturedProducts(params = {}) {
  return apiGet("/catalog/products/", { ...params, is_featured: true });
}

export function getProductBySlug(slug) {
  return apiGet(`/catalog/products/${slug}/`);
}

export function getProductById(id) {
  return apiGet(`/catalog/admin/products/${id}/`);
}

export function getAdminProducts(params = {}) {
  return apiGet("/catalog/admin/products/", params);
}

export function createProduct(payload) {
  return apiPost("/catalog/admin/products/", payload);
}

export function updateProduct(id, payload) {
  return apiPut(`/catalog/admin/products/${id}/`, payload);
}

export function patchProduct(id, payload) {
  return apiPatch(`/catalog/admin/products/${id}/`, payload);
}

export function deleteProduct(id) {
  return apiDelete(`/catalog/admin/products/${id}/`);
}